import { render, staticRenderFns } from "./ImageTextCard.vue?vue&type=template&id=bd67dd4e&scoped=true&"
import script from "./ImageTextCard.vue?vue&type=script&lang=js&"
export * from "./ImageTextCard.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextCard.vue?vue&type=style&index=0&id=bd67dd4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd67dd4e",
  null
  
)

export default component.exports